import { SEGMENTO_SERVICO, SEGMENTO_COMERCIO, SEGMENTO_INDUSTRIA } from '@/enums/company'

const NOMENCLATURA_PEDIDO = 1

const DESCRICAO_PEDIDO = 'Pedido'
const DESCRICAO_PLURAL_PEDIDO = 'Pedidos'
const ICONE_PEDIDO = 'mdi-cart-arrow-up'
const ROTA_PEDIDO = '/pedidos'

const DESCRICAO_ORDEM_SERVICO = 'Ordem de serviço'
const DESCRICAO_PLURAL_ORDEM_SERVICO = 'Ordens de serviço'
const ICONE_ORDEM_SERVICO = 'mdi-tools'
const ROTA_ORDEM_SERVICO = '/ordensServico'

const NOMECLATURA_POR_SEGMENTO_EMPRESA = {
  [NOMENCLATURA_PEDIDO]: {
    [SEGMENTO_SERVICO]: {
      descricao: DESCRICAO_ORDEM_SERVICO,
      descricao_plural: DESCRICAO_PLURAL_ORDEM_SERVICO,
      icone: ICONE_ORDEM_SERVICO,
      pronome: 'f',
      route: ROTA_ORDEM_SERVICO,
    },
    [SEGMENTO_COMERCIO]: {
      descricao: DESCRICAO_PEDIDO,
      descricao_plural: DESCRICAO_PLURAL_PEDIDO,
      icone: ICONE_PEDIDO,
      pronome: 'm',
      route: ROTA_PEDIDO,
    },
    [SEGMENTO_INDUSTRIA]: {
      descricao: DESCRICAO_PEDIDO,
      descricao_plural: DESCRICAO_PLURAL_PEDIDO,
      icone: ICONE_PEDIDO,
      pronome: 'm',
      route: ROTA_PEDIDO,
    },
  },
}

const format = {
  upper: (v) => v.toUpperCase(),
  lower: (v) => v.toLowerCase(),
  capital: (v) => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase(),
}

const TIPO_NORMAL = 1
const TIPO_PLURAL = 2

function getNomenclatura (tipo, segmento = SEGMENTO_COMERCIO) {
  const item = NOMECLATURA_POR_SEGMENTO_EMPRESA[tipo]?.[segmento]
  if (!item) {
    return 'ERRO NA NOMENCLATURA'
  }

  return {
    icon: item.icone,
    upper: (tipo = TIPO_PLURAL) => format.upper(tipo === TIPO_NORMAL ? item.descricao : item.descricao_plural),
    lower: (tipo = TIPO_PLURAL) => format.lower(tipo === TIPO_NORMAL ? item.descricao : item.descricao_plural),
    capital: (tipo = TIPO_PLURAL) => format.capital(tipo === TIPO_NORMAL ? item.descricao : item.descricao_plural),
    route: item.route,
    pronome: item.pronome === 'm' ? 'seus' : 'suas',
  }
}

export {
  NOMENCLATURA_PEDIDO,

  DESCRICAO_PEDIDO,
  ICONE_PEDIDO,
  DESCRICAO_ORDEM_SERVICO,
  ICONE_ORDEM_SERVICO,

  getNomenclatura,
  TIPO_NORMAL,
  TIPO_PLURAL,
}
